export const REMEMBER_ME_VALUES = ['never', '10 hours', '1 day', '3 days', '7 days'] as const;
export type RememberMeValues = (typeof REMEMBER_ME_VALUES)[number];

export interface VerifyRequest {
  value: string;
  rememberFor: RememberMeValues | null;
}
